import React from "react";

const CardDesign = ({ carditems }) => {
  const heading = carditems?.find((item) => item?.heading)?.heading;
  const para = carditems?.find((item) => item?.para)?.para;
  const subheading = carditems?.find((item) => item?.subheading)?.subheading;

  // Filter only items with title to render as cards
  const procedureSteps = carditems?.filter((item) => item?.title);

  return (
    <>
      <div className="container my-5" id="procedure">
        <div className="row justify-content-center text-center">
          <div className="col-12 col-md-10">
            {heading && <h2 className="fw-bold mb-3 title">{heading}</h2>}
            {subheading && <h5 className="mt-3 ">{subheading}</h5>}
            {para && <p className="text-muted">{para}</p>}
          </div>
        </div>
      </div>
      <div className="row g-4 mx-auto">
        {procedureSteps?.map((item, index) => (
          <div key={index} className="col-12 col-lg-6">
            <div className="card h-100 shadow border-0 rounded-4">
              <div className="card-body" style={{ padding: "2rem 1rem" }}>
                {/* Icon + Title in one row */}
                <div className="d-flex align-items-center justify-content-center justify-content-lg-start gap-3 ">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: "50px",
                      height: "50px",
                      background: "linear-gradient(135deg, #c69933, #bdaa7d)",
                      color: "white",
                      fontSize: "1.25rem",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                      flexShrink: 0,
                    }}
                  >
                    <i className={item.icon}></i>
                  </div>
                  <h5 className="fw-bold text-dark">{item.title}</h5>
                </div>

                {/* Description below */}
                <p className="text-muted medium ">
                  {item.description || item.desc || item.summary}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default CardDesign;